<app-exam-address-form (onSubmitCallback)="onSubmit($event[0])"></app-exam-address-form>
